import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import AkodeAccountTransactionTableFilter from "../Filters/AkodeAccountTransactionTableFilter";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import config from "../../util/ApiforContext";
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const AccountTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [tabQueryKey, setTabQueryKey] = useState(undefined);
  const [tabQuery, setTabQuery] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const callback= (key)=> {
    setTabQueryKey(key);
    const { skip, take } = tableDataQueryOptions;
    RequestHandler.get(
      key !== undefined && key !== "" && key !== "999" ? `/ToslaAccountTransaction?$count=true&$filter= statusValue eq ${key}&$skip=${skip}&$top=${take}` : `/ToslaAccountTransaction?$count=true&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });
      RequestHandler.get(
        key !== undefined && key !== "" && key !== "999" ? `/ToslaAccountTransaction?$count=true&$filter= statusValue eq ${key}&$select=Amount` : `/ToslaAccountTransaction?$count=true&$select=Amount`
        ).then((response) => {
          var totalAmount = 0;
          response.value.map((item)=>{
            totalAmount += item.amount;
          })
          setTotalAmount(
            totalAmount.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + ' ₺'
          )
        });
  }

  const getFilterQuery = () => {
    const { filter } = tableDataQueryOptions;
    const conditions = [];
    let query = "";

    if (filter) {
      conditions.push(filter);
    }
    if(tabQueryKey !== undefined && tabQueryKey !== "999"){
      conditions.push(`statusValue eq ${tabQueryKey}`);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const getTableData = (key) => {
    setTableData({
      ...tableData,
      loading: true,
    });
    const { skip, take } = tableDataQueryOptions;

     RequestHandler.get(
      `/ToslaAccountTransaction?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      });

      RequestHandler.get(
        `/ToslaAccountTransaction?$count=true&${getFilterQuery()}&$select=Amount`
        ).then((response) => {
          var totalAmount = 0;
          response.value.map((item)=>{
            totalAmount += item.amount;
          })
          setTotalAmount(
            totalAmount.toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) + ' ₺'
          )
        });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const onClickExportExcel = () => {
     const hideMessage = message.loading("Excel indiriliyor...", 0);

      RequestHandler.post(
        `/ToslaAccountTransaction/ExportExcel`,
        {
          query: getFilterQuery(),
        },
        false
      ).then((response) => {
        hideMessage();
        if (response) {
          const base64String = response.base64;

          // Base64 verisini binary'e çevir
          const byteCharacters = atob(base64String);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
    
          // Blob oluştur
          const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
          // URL oluştur
          const url = URL.createObjectURL(blob);
    
          // İndirme işlemini başlat
          const a = document.createElement('a');
          a.href = url;
          a.download = response.fileName; // İndirilmiş dosyanın ismi
          document.body.appendChild(a);
          a.click();
    
          // Temizlik
          URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }
      });
  };

  const tableColumns = [
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDate",
      align:'center',
      render: (data, row, index) => moment(data).format('L LTS'),
    },
    {
      title: "Firma İşlem Id",
      dataIndex: "orderId",
    },
    {
      title: "User Id",
      dataIndex: "sbuxUserId",
    },
    {
      title: "İşlem Id",
      dataIndex: "transactionId",
    },
    {
      title: "İşlem Versiyon",
      dataIndex: "positionVersion",
    },
   
    {
        title: "Tutar",
        dataIndex: "amount",
        sorter: (a, b) => a.amount - b.amount,
        render: ColumnHelper.renderDecimal,
      },
      
      {
        title: "Durum",
        dataIndex: "status",
        align:"center",
        render: (data,row,index) => {
          if(data === "Success"){
            return <div style={{color:'#07af2b'}}>Success</div>
          }else if(data === "Failed"){
            return <div style={{color:'darkred'}}>Failed</div>
          }else if(data === "Retry"){
            return <div style={{color:'#ffa90a'}}>Retry</div>
          }else if(data === "Reversed"){
            return <div style={{color:'#08b4db'}}>Reversed</div>
          }
        }
      },
 
    {
      title: "İade işlem Id",
      dataIndex: "returnTransactionId",
    },
    {
      title: "İade İşlem Versiyon",
      dataIndex: "returnPositionVersion",
    },
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> HESAP HAREKETLERİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>
      <AkodeAccountTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isStatusFilter = {tabQueryKey !== undefined && tabQueryKey !== "" && tabQueryKey !== "999" ? false : true}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Col xs={24} md={24} lg={24} style={{textAlign: 'right',fontSize:21}}>
        Toplam Tutar : {totalAmount}
      </Col>
      <Tabs defaultActiveKey="999" onChange={callback}>
              <TabPane tab={<span>Tümü</span>} key="999">
              </TabPane>
              <TabPane tab={<span style={{color:'green'}}>Success</span>} key="0">
              </TabPane>
              <TabPane tab={<span style={{color:'darkred'}}>Failed</span>} key="1">
             </TabPane>
              <TabPane tab={<span style={{color:'#ffa90a'}}>Retry</span>} key="2">
             </TabPane> 
              <TabPane tab={<span style={{color:'#08b4db'}}>Reversed</span>} key="3">
              </TabPane>
            </Tabs>
    
            <Row id="tableArea">
                <Col span={24}>
                  <Table
                    columns={tableColumns.filter((column) => !column.isRowDetail)}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="Veri Yok"
                        />
                      ),
                    }}
                    style={{
                      overflowX: "auto",
                      maxHeight: "100%",
                      width: "100%",
                    }}
                    rowKey="id"
                    filterable={true}
                    sortable={true}
                    pageable={true}
                    onChange={paging}
                    pagination={{
                      defaultPageSize: tableDataQueryOptions.take,
                      pageSizeOptions: ["15", "25", "50", "100"],
                      total: tableData.total,
                      current: tableDataQueryOptions.current,
                    }}
                    dataSource={tableData.data}
                    loading={tableData.loading}
                    size="small"
                  />
                </Col>
              </Row>
      
    </>
  );
};

export default AccountTransaction;
